module.exports = __webpack_public_path__ + "static/orthodontics02-f61234c98840d2c4fd6fc004dcfc8c58.jpg";